<template lang="pug">
  GenericGraph(
    nameElementDiv="graficoConversasAssunto",
    :graphData="dadosGrafico",
    :graphLayout="layout",
  )
</template>

<script>
import { GenericGraph } from 'sicarf-components'
import { colors } from '@/utils/constantes'

export default {
  name: 'GraficoPeriodoMensal',
  components: {
    GenericGraph
  },
  props: {
    dadosLabels: {
      required: true
    }
  },
  data () {
    return {
      dados: [],
      layout: {
        showlegend: false,
        height: 350,
        xaxis: {
          showticklabels: true,
          title: '',
          titlefont: {
            size: 16,
            color: 'rgb(107, 107, 107)'
          },
          automargin: true,
          fixedrange: false,
          range: []
        },
        yaxis: {
          title: 'Quantidade de conversas',
          titlefont: {
            size: 16,
            color: 'rgb(107, 107, 107)'
          }
        },
        hovermode: 'closest',
        margin: {
          b: 60,
          l: 60,
          t: 40
        }
      },
      colors,
      loading: true
    }
  },
  computed: {
    dadosWithColor () {
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        color: this.colors[index]
      }))
    },

    dadosGrafico () {
      const dadosGrafico = []

      for (let index = 0; index < this.dadosWithColor.length; index++) {
        dadosGrafico.push({
          x: [this.dadosWithColor[index].chave],
          y: [this.dadosWithColor[index].quantidade],
          type: 'bar',
          hovertemplate: `<b>%{label}</b><br>%{y} conversas<br><extra></extra>`,
          name: this.dadosWithColor[index].chave,
          marker: { color: [this.dadosWithColor[index].color] }
        })
      }

      return dadosGrafico
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/graficos/GraficoPeriodoMensal.vue